import { AllFulfillmentTypesType, OrderV2Dto } from "@sellar-io/api-v2/types";
import { formatFulfillmentTypeLabel } from "./formatFulfillmentTypeLabel";

export const getFulfillmentChangeReasonOptions = ({
  newFulfillmentType,
}: {
  newFulfillmentType: AllFulfillmentTypesType;
}): Array<{
  value: OrderV2Dto.OrderConfirmRequestType["fulfillmentChangeReason"];
  label: string;
}> => {
  const fulfillmentTypeLabel = formatFulfillmentTypeLabel(newFulfillmentType);

  return [
    {
      value: "can-deliver-faster",
      label: `I can deliver to my customer faster via ${fulfillmentTypeLabel}`,
    },
    {
      value: "can-deliver-more-cost-effectively",
      label: `I can deliver to my customer more cost-effectively via ${fulfillmentTypeLabel}`,
    },
    {
      value: "prefer-own-vehicles",
      label: "I prefer to deliver to this customer via my own vehicles",
    },
    { value: "other", label: "Other" },
  ];
};
